import React from 'react'
import ReactDOM from 'react-dom'
import { Link } from 'react-router-dom'
import { Subject } from 'rxjs';
import ScrollSwipe from 'scroll-swipe'
import { connect } from 'react-redux'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { fetchAlbumsIfNeeded, fetchAlbumIfNeeded, fetchAlbumsSearchIfNeeded } from '~/reviews/actions'
import { renderRoutes } from 'react-router-config'
import Album  from './Album'

import subjects from '~/comm'
//const closeModal = new Subject()


const AlbumEnter = (props) => (
  <CSSTransition
    {...props}
    timeout={400}
    classNames="fade"
  />

)


class Albums extends React.Component {
  constructor() {
    super();
    // Setting up initial state
    this.state = {
      data: [],
      count: 0,
      search: null
    }
    //subjects.closeModal.subscribe(x => this.modalClosed(x) )
    this.albumClick = this.albumClick.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.handleNegClick = this.handleNegClick.bind(this)
    this._handleEnter = this._handleEnter.bind(this)
    this.scrollCb = this.scrollCb.bind(this)
    this.touchCb = this.touchCb.bind(this)
    this.searchAlbums = this.searchAlbums.bind(this)
    this.vertical = 0
    this.horizontal = 0
    this.ss = null
    this.scrollTimeOut = null
    this.preventDefaultWorkAround = null

    this.keyevent = null
 }

 static fetchData(store, route, match) {
  if(match.params.id) {
      return Promise.all([
        store.dispatch(fetchAlbumsIfNeeded(0)),
        store.dispatch(fetchAlbumIfNeeded(match.params.id))
      ])
   }
   return Promise.all([
     store.dispatch(fetchAlbumsIfNeeded(0))
   ])
 }

 componentDidMount() {
   document.getElementsByTagName('body')[0].className = 'albums';
   subjects.currentComponent.next('new releases')
   const { match, albums } = this.props
   var id = null;
   if(match.params && match.params.id){
      //  this.setState({ count: Number(match.params.id) }, this.getAlbums)
   }
   else {
     this.getAlbums()
   }
   window.scrollTo(0, 0)
   this.startScrollSwipe()
   if(match.params && match.params.id) {
     let idx = albums.items.findIndex( (item) => item.relPath == match.params.id )
     if (idx > -1) {
       this.scrollTo(document.querySelector('.album-item:nth-of-type('+ (idx + 1) +')').offsetTop, 100 )
    }

   }
   else {
     this.keyevent = document.addEventListener('keydown', this.handleKeyPress)
   }




 }

 componentWillReceiveProps(nextProps) {
   const {search, dispatch} = nextProps
   if(search.searchTerm !== this.props.search.searchTerm) {
    //  dispatch(fetchAlbumsSearchIfNeeded(search.searchTerm))
   }
   if(nextProps.match.params.id && nextProps.match.params.id != this.props.match.params.id ) {
     let idx = nextProps.albums.items.findIndex( item => item.path == nextProps.match.params.id )
     if(idx > -1) {
      this.scrollTo(document.querySelector('.album-item:nth-of-type('+ (idx + 1) +')').offsetTop, 100 )
      document.removeEventListener('keydown', this.handleKeyPress)
      console.log("WITH REVIEW")
      document.querySelector('#album--review'),focus()
    }
   }
   else if(! nextProps.match.params.id ) {
     console.log("NO REVIEW")
     this.keyevent = document.addEventListener('keydown', this.handleKeyPress)
   }
 }

 componentWillUpdate(nextProps) {
   const { location } = this.props
 }

 componentDidUpdate() {
   const { history, match } = this.props
   //THIS MOVES TO THE TOP!
   //ReactDOM.findDOMNode(this).scrollIntoView();
   let context = ReactDOM.findDOMNode(this)
   this.startScrollSwipe()
 }


 componentWillUnmount() {
   document.getElementsByTagName('body')[0].className = '';
   this.ss.killAll();
   if (this.preventDefaultWorkAround === true) {
     document.getElementsByTagName('body')[0].style.touchAction = ''
   }
   document.body.style.overflow = null
   document.removeEventListener('keydown', this.handleKeyPress)
   //window.removeEventListener('wheel', this.handleScroll)
   //window.removeEventListener('touchmove', this.handleScroll)
 }

 startScrollSwipe() {
   this.ss = (typeof document !== 'undefined') ? new ScrollSwipe({
     target: document.getElementById('album--list'), // Element must be a single dom-node per ScrollSwipe Instance
     scrollSensitivity: 10, // The lower the number, the more sensitive
     touchSensitivity: 0, // The lower the number, the more senitive
     scrollPreventDefault: true, // prevent default option for scroll events
     touchPreventDefault: true, // prevent default option for touch events
     scrollCb: this.scrollCb,  // The action you wish to perform when a scroll reacts (details below)
     touchCb: this.touchCb // The action you wish to perform when a touch reacts (details below)
   }) : null
 }

  modalClosed(x) {
    document.body.style.overflow = null
    this.ss = new ScrollSwipe({
      target: document.body, // Element must be a single dom-node per ScrollSwipe Instance
      scrollSensitivity: 10, // The lower the number, the more sensitive
      touchSensitivity: 0, // The lower the number, the more senitive
      scrollPreventDefault: true, // prevent default option for scroll events
      touchPreventDefault: true, // prevent default option for touch events
      scrollCb: this.scrollCb,  // The action you wish to perform when a scroll reacts (details below)
      touchCb: this.touchCb // The action you wish to perform when a touch reacts (details below)
    });
    let context = ReactDOM.findDOMNode(this)
    let activeNode = context.querySelector('.active')
    if (activeNode) {
      activeNode.classList.toggle('active')
    }
  }

  handleKeyPress(e) {
    if(e.key === 'PageDown' || e.key === 'ArrowDown' ) {
      this.vertical++
    }
    else if(e.key === 'PageUp' || e.key === 'ArrowUp' ) {
      this.vertical--
    }
    else {
      return
    }
    console.log('KEY')
    var allalbums = document.querySelectorAll('.album-list div.album-item')

    if (this.vertical > allalbums.length -1 ) {
      this.setState(prevState => ({
        count: prevState.count + 1
      }), this.getAlbums )
    } else if ( this.vertical < 0 && this.state.count > 0) {
      this.setState(prevState => ({
        count: prevState.count - 1
      }), this.getAlbums )
    } else {
      if (this.vertical < 0 && this.state.count <= 0) {
        this.vertical = 0
      }
      if (this.scollTimeOut) {
        clearTimeout(this.scrollTimeOut)
      }
      //window.scrollTo(0, allalbums[this.vertical].offsetTop )
      this.scrollTo(allalbums[this.vertical].offsetTop, 100)
    }
  }


 getAlbums() {
   const { dispatch } = this.props

   dispatch(fetchAlbumsIfNeeded(this.state.count))
 }


  handleScroll(event) {
    // do something like call `this.setState`
    // access window.scrollY etc
  }


  handleNegClick() {
    this.setState(prevState => ({
      count: prevState.count - 1
    }), this.getAlbums )
    console.log('did it')
  }
  _handleEnter() {
    console.log('does it happen?')
    this.setState(prevState => ({
      count: prevState.count + 1
    }), this.getAlbums )
    console.log('but but')
  }

  _handleWaypointLeave() {
    console.log('and this'  )
  }

  handleClick() {
    this.setState(prevState => ({
      count: prevState.count + 1
    }), this.getAlbums )
    console.log('did it')
  }

  handleEv(ev) {
    //console.log(ev)
    if(ev) {
      var allalbums = document.querySelectorAll('.album-list div.album-item')
      if (ev.direction === 'VERTICAL') {
        if (ev.intent === 0) {
          this.vertical--
        } else {
          this.vertical++
        }
      }
      if (this.vertical > allalbums.length -1 ) {
        this.setState(prevState => ({
          count: prevState.count + 1
        }), this.getAlbums )
      } else if ( this.vertical < 0 && this.state.count > 0) {
        this.setState(prevState => ({
          count: prevState.count - 1
        }), this.getAlbums )
      } else {
        if (this.vertical < 0 && this.state.count <= 0) {
          this.vertical = 0
        }
        if (this.scollTimeOut) {
          clearTimeout(this.scrollTimeOut)
        }
        //window.scrollTo(0, allalbums[this.vertical].offsetTop )
        this.scrollTo(allalbums[this.vertical].offsetTop, 100)
        //console.log(this.vertical)
      }
    }
  }
  scrollCb(ev){
    this.handleEv(ev)
    //console.log(ev)
    this.ss.listen()
  }
  touchCb(ev){
    if (! this.preventDefaultWorkAround) {
      if (! ev.startEvent.defaultPrevented) {
        this.preventDefaultWorkAround = true
        document.getElementsByTagName('body')[0].style.touchAction = 'none'
        //console.log('only once')
      }
    }
    this.handleEv(ev)
    this.ss.listen()
  }

  scrollTo(to, duration) {
    var start = document.getElementById('album--list').scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;
    if (this.scollTimeOut) {
      clearTimeout(this.scrollTimeOut)
    }

    var easeInOutQuad = function (t, b, c, d) {
      t /= d/2;
    	if (t < 1) return c/2*t*t + b;
    	t--;
    	return -c/2 * (t*(t-2) - 1) + b;
    }

    var _this = this
    var animateScroll = function(){
        currentTime += increment;
        var val = easeInOutQuad(currentTime, start, change, duration);
        document.getElementById('album--list').scrollTop = val;
        if(currentTime < duration) {
          _this.scrollTimeOut = setTimeout(animateScroll, increment);
        }
    }
    animateScroll();
  }

  searchAlbums(event){
    this.setState({
      search: event.target.value
    })
  }

  albumClick(ev){
    //this.ss.killAll()
    //var node = ev.target.parentNode.parentNode
    //node.classList.toggle('active')
    //document.body.style.overflow = 'hidden'
  }


  render() {
    const { albums, route } = this.props
    let albumsList = albums.items.slice(0)
    var titles = []
    var api = "//jeff.4zzz.org.au"

    let review = null
    if (this.props.match.params.id && this.props.albums.reviews[this.props.match.params.id] &&  this.props.albums.reviews[this.props.match.params.id].isFetching !== true) {
      const activeReview = this.props.albums.reviews[this.props.match.params.id]
      review = {
        field_review_album_artist: activeReview.field_review_album_artist[0].value,
        field_review_album_title: activeReview.field_review_album_title[0].value,
        field_review_image: activeReview.field_review_image[0].url,
        nid: String(activeReview.nid[0].value),
        path: activeReview.path[0].alias.replace('/reviews/albums/', ''),
        title: activeReview.title[0].value
      }
    }
    if (albums.search.items.length > 0) {
      albumsList = albums.search.items
    }
    // if(review && _.findIndex(albumsList, { nid: review.nid} ) === -1 ) {
    //   albumsList.unshift(review)
    // }
    if(review && albumsList.findIndex( i => i.nid === review.nid) === -1 ) {
      albumsList.unshift(review)
    }
    

    albumsList.forEach( (item, index) => {
      item.relPath = item.path.replace("/reviews/albums/", "")
      titles.push(
        <AlbumEnter key={index}>
        <div className="album-item" key={item.nid}>
          <div className="album-entry">
          <h3 className="album-name">
            <span className="album-artist">
            {item.field_review_album_artist}
            </span>
            <span className="album-title">
            {item.field_review_album_title}
            </span>
          </h3>
          <Link
            key={item.nid[0].value}
            to={{
            pathname: `/reviews/album/${item.relPath}`
          }}>
          <img className="album" src={ '//jeff.4zzz.org.au/' +  item.field_review_image} />
          </Link>
          </div>
        </div>
        </AlbumEnter>
      )
    })
    let activeReview = (this.props.match.params.id ) ? 'active' : null
    return (
      <div className="content">
      <div id="album--review">
        { this.props.match.params.id ? <Album albumid={this.props.match.params.id} /> : null }
        {/*renderRoutes(route.routes, { someProp: 'these extra props are optional' })*/}

      </div>

      <div id="album--list" className={activeReview} >
        <div className="row">
          <div className="album-list">
            { titles ?
            <TransitionGroup>
            {titles}
            </TransitionGroup>
            :null }
          </div>
          { albumsList.length > 0 && this.state.data.useWayPoint ? <Waypoint onEnter={this._handleEnter} onLeave={this._handleWaypointLeave}><div>Some content here</div></Waypoint> : null }
        </div>
      </div>

      </div>
    )

   }
}

export default connect(state => ({ albums: state.albums, search: state.search })) (Albums)
